var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConvert = function SvgConvert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.033 21.988a9.525 9.525 0 0 1 .49-19.036l.49.013c5.033.255 9.035 4.416 9.035 9.512 0 5.26-4.265 9.523-9.525 9.523zm4.3-10.464h-2.857V6.762l-4.762 6.667h2.857v4.761zM20.318 5.662l.117-.27c.21-.48.586-.862 1.056-1.07l.362-.162a.252.252 0 0 0 0-.458l-.341-.152a2.08 2.08 0 0 1-1.072-1.107l-.12-.29a.241.241 0 0 0-.449 0l-.12.29c-.206.496-.59.893-1.072 1.107l-.342.152a.252.252 0 0 0 0 .458l.362.161c.47.21.847.591 1.056 1.071l.118.27a.241.241 0 0 0 .444 0"
  })));
};
export default SvgConvert;